import React from 'react'
import { Link } from 'react-router-dom'

const defaultFeatures = [
  {
    title: 'Forms',
    href: '/features/forms',
    description:
      'Create powerful feedback forms, link them dynamically',
    image: {
      src: '',
      alt: 'Related feature preview',
    },
  },
  {
    title: 'Branch',
    href: '/features/branches',
    description:
      'Track feedback by branch, HQ sees everything',
    image: {
      src: '',
      alt: 'Related feature preview',
    },
  },
  {
    title: 'Email Campaign',
    href: '/features/email-campaign',
    description:
      'Engage customers with automated, targeted emails',
    image: {
      src: '',
      alt: 'Related feature preview',
    },
  },
  {
    title: 'Feedback',
    href: '/features/feedback',
    description:
      'Manage feedback, complaints, and commendations in one place',
    image: {
      src: '',
      alt: 'Related feature preview',
    },
  },
  {
    title: 'Departments',
    href: '/features/department',
    description:
      'Organize feedback by department, assign clear owners',
    image: {
      src: '',
      alt: 'Related feature preview',
    },
  },
]

const FeaturesRelated = ({ content = {} }) => {
  const {
    title = 'Related features',
    subtitle = 'Explore more ways to scale feedback collection',
    viewAllHref = '/features',
    items = defaultFeatures,
  } = content

  return (
    <section className=" py-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">

        {/* Header Row */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 mb-14">
          <div data-aos="fade-right">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
              {title}
            </h2>
            <p className="text-gray-600 mt-3 text-base md:text-lg">
              {subtitle}
            </p>
          </div>

          <div data-aos="fade-left">
            <Link to={viewAllHref} className="btn btn-primary w-max px-6 py-3 rounded-xl text-white font-medium shadow-md hover:opacity-90 transition">
              View all features
            </Link>
          </div>
        </div>
      </div>

      {/* Horizontal Scroll Cards */}
      <div
        className="scrollbar-hidden flex gap-6 overflow-x-auto overflow-y-hidden pb-2 snap-x snap-mandatory"
      >
          {items.map((item, index) => (
            <Link
              key={index}
              to={item.href || '/features'}
              data-aos="fade-up"
              data-aos-delay={index * 150}
              className="related-scroll-start min-w-[280px] sm:min-w-[340px] lg:min-w-[380px] bg-white rounded-3xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-md transition snap-start"
            >
              <div className="w-full h-52 sm:h-60">
                {item.image?.src ? (
                  <img src={item.image.src} alt={item.image.alt || 'Related feature preview'} className="w-full h-full object-cover" />
                ) : (
                  <div className="w-full h-full bg-gray-200" />
                )}
              </div>

              {/* Content */}
              <div className="p-6 space-y-3">
                <h3 className="text-lg md:text-xl font-semibold text-gray-900">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-sm md:text-base">
                  {item.description}
                </p>
              </div>
            </Link>
          ))}
      </div>
    </section>
  )
}


export default FeaturesRelated
